import { RootState } from 'src/redux/store'

interface StoreSelector {
  status: string
  data: Oms.V4.Store[]
}

export const selectStore = (state: RootState): StoreSelector => state['@stores']
